import React, { createContext, useContext } from 'react';
import { useHttpClientIntegration } from '@/shared/infra/http/HttpClientContext';
import { FetchPendingDhsSsaUseCase } from '../../application/use-cases/FetchPendingDhsSsaUseCase';
import { ApiPendingDhsSsaRepository } from '../repositories/ApiPendingDhsSsaRepository';

interface PendingDhsSsaDIContextType {
  pendingDhsSsaUseCase: FetchPendingDhsSsaUseCase;
}

const PendingDhsSsaDIContext = createContext<PendingDhsSsaDIContextType | undefined>(undefined);

export const PendingDhsSsaDIProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const httpClient = useHttpClientIntegration();

  const repository = new ApiPendingDhsSsaRepository(httpClient);
  const pendingDhsSsaUseCase = new FetchPendingDhsSsaUseCase(repository);

  return (
    <PendingDhsSsaDIContext.Provider value={{ pendingDhsSsaUseCase }}>
      {children}
    </PendingDhsSsaDIContext.Provider>
  );
};

export const usePendingDhsSsaDIContext = (): PendingDhsSsaDIContextType => {
  const context = useContext(PendingDhsSsaDIContext);
  if (!context) {
    throw new Error('usePendingDhsSsaDIContext must be used within PendingDhsSsaDIProvider');
  }
  return context;
};
